import './text-toggle.styl';

function TextToggle({
  leftText, rightText, active, setActive, 
}) {
  return (
    <button 
      className="text-toggle"
      type="button"
      onClick={() => setActive(!active)}
    >
      <div className={`text-toggle__left${active ? ' active' : ''}`}>
        {leftText}
      </div>
      <div className={`text-toggle__right${!active ? ' active' : ''}`}>
        {rightText}
      </div>
    </button>
  )
}

export default TextToggle;